/**
 * 部门人员
 */

 import {
  get,
  post,
  put,
  del
} from '@/util/request'

/**
 * 根据Id查询
 * @param {*} Id
 * @returns
 */
export const SelectDepartmentUserById = (Id) => {
  return get('/api/app/DepartmentUser?CurrentId=' + Id);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddDepartmentUser = (data) => {
  return post('/api/app/DepartmentUser', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyDepartmentUser = (data) => {
  return put('/api/app/DepartmentUser', data, {});
}

/**
 * 分页获取
 * @param {*} data
 * @returns
 */
export const GetDataDepartmentUserList = (data) => {
  return post('/api/app/DepartmentUser/list', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteDepartmentUser = (id) => {
  return del('/api/app/DepartmentUser/' + id, {}, {});
}

/**
 * 1,通过部门id获取部门下用户
 */
 export const GetDataByDepartmentId = (data) => {
  return post('/api/app/departmentUser/getDataByDepartmentId', data, {});
}

/**
 * 2,通过部门id获取部门所属公司下不属于该部门的用户
 */
 export const GetDataNotInDepartment = (data) => {
  return post('/api/app/departmentUser/getDataNotInDepartment', data, {});
}

/**
 * 3,往部门中增加用户
 */
 export const AddUserToDepartment = (id,data) => {
  return post('/api/app/departmentUser/'+id+'/userToDepartment', data, {});
}

/**
 * 4,往部门中移除用户
 */
 export const RemoveUserToDepartment = (data) => {
  return post('/api/app/departmentUser/removeUserToDepartment', data, {});
}
